var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverytimeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20851 1.87562L6.61651 1.26662C6.60447 1.2538 6.58989 1.24363 6.57371 1.23675C6.55753 1.22986 6.5401 1.22641 6.52251 1.22662V1.22662C6.50488 1.22609 6.48735 1.2294 6.47112 1.2363C6.45489 1.24321 6.44036 1.25355 6.42851 1.26662L2.32251 5.40262L0.828511 3.90862C0.816373 3.89591 0.801786 3.8858 0.785629 3.87889C0.769473 3.87198 0.752083 3.86842 0.734511 3.86842C0.71694 3.86842 0.699551 3.87198 0.683394 3.87889C0.667238 3.8858 0.65265 3.89591 0.640512 3.90862L0.0405121 4.50862C0.027691 4.5211 0.0175008 4.53603 0.0105429 4.55252C0.00358489 4.56901 0 4.58672 0 4.60462C0 4.62251 0.00358489 4.64023 0.0105429 4.65672C0.0175008 4.6732 0.027691 4.68813 0.0405121 4.70062L1.92551 6.58562C2.02793 6.69701 2.16867 6.76559 2.31951 6.77762C2.46736 6.76422 2.60561 6.69864 2.70951 6.59262V6.59262L7.20951 2.06962C7.23355 2.04297 7.24677 2.00831 7.24658 1.97242C7.2464 1.93654 7.23282 1.90201 7.20851 1.87562V1.87562Z",
    fill: "#E10092"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 2.25062L9.61651 1.64162C9.60447 1.6288 9.58989 1.61863 9.57371 1.61175C9.55753 1.60486 9.5401 1.60141 9.52251 1.60162V1.60162C9.50488 1.60109 9.48735 1.6044 9.47112 1.6113C9.45489 1.61821 9.44036 1.62855 9.42851 1.64162L5.32251 5.77762L3.82851 4.28362C3.81637 4.27091 3.80179 4.2608 3.78563 4.25389C3.76947 4.24698 3.75208 4.24342 3.73451 4.24342C3.71694 4.24342 3.69955 4.24698 3.68339 4.25389C3.66724 4.2608 3.65265 4.27091 3.64051 4.28362L3.04051 4.88362C3.02769 4.8961 3.0175 4.91103 3.01054 4.92752C3.00358 4.94401 3 4.96172 3 4.97962C3 4.99751 3.00358 5.01523 3.01054 5.03172C3.0175 5.0482 3.02769 5.06313 3.04051 5.07562L4.92551 6.96062C5.02793 7.07201 5.16867 7.14059 5.31951 7.15262C5.46736 7.13922 5.60561 7.07364 5.70951 6.96762V6.96762L10.2095 2.44462C10.2335 2.41797 10.2468 2.38331 10.2466 2.34742C10.2464 2.31154 10.2328 2.27701 10.2085 2.25062V2.25062Z",
    fill: "#E10092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4",
    x: 2,
    y: 0.601562,
    width: 9.24659,
    height: 7.55105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverytimeIcon2);
export default __webpack_public_path__ + "static/media/deliverytime-icon2.a335f5d3965e802b3c5437989be359f9.svg";
export { ForwardRef as ReactComponent };